import { IEvent } from '@studyportals/event-aggregation-service-interface';
import { LocalizedContentEventType } from '../LocalizedContentEventType';
import { ILocalizedContentService } from './I-LocalizedContentService';

export class LocalizedContentServiceReadyEvent implements IEvent {
	//required
	public readonly timestamp: Date;
	public static EventType: string = LocalizedContentEventType.LOCALIZED_CONTENT_SERVICE_READY;
	public readonly eventType = LocalizedContentServiceReadyEvent.EventType;

	//optional
	public readonly localizedContentService: ILocalizedContentService;

	constructor(localizedContentService: ILocalizedContentService) {
		this.timestamp = new Date();
		this.localizedContentService = localizedContentService;
	}
}
